/**
 * 暂时解决antd升级中的报错
 * @author tylerzzheng
 */
import React from 'react'
import { Select } from 'antd'
import { currCompanyList } from '@store/session-store'
import { useStore } from 'zustand'

const CompanySelector: React.FC<React.PropsWithChildren<any>> = (props) => {
  const currCompanyListData = useStore(currCompanyList)
  return (
    <Select allowClear {...props}>
      {currCompanyListData.map(company => (
        <Select.Option key={company.companyId} value={company.companyId}>{company.companyName}</Select.Option>
      ))}
    </Select>
  )
}
export default CompanySelector
